import { TechnicianSettings } from "operations/schema/schema";

const technicianSettings: TechnicianSettings = {
  allowChangeInvoiceType: false,
  allowNegativeStock: false,
  allowEditMachineInstallDate: false,
  allowMoveStock: false,
  allowOrderStock: false,
  allowUpdateStock: false,
  syncSalesPrice: false,
  syncCostPrice: false,
  syncFreqList: false,
  isAllowedMobileMachineEdit: false,
  canCreateJob: false,
  customerSatisfactionEnabled: false,
  simplePlannerAccess: false,
  advancedPlannerAccess: false,
  mapboxToken: "",
  requireActionCode1: false,
  requireActionCode2: false,
  requireActionCode3: false,
  requireActionText: false,
  requireActionTextReturn: false,
  requireCheckListId: false,
  requireCustomerSignature: false,
  requireCustomerSignatureName: false,
  requireTechnicianSignature: false,
  requireMeterReading: false,
  requireReference: false,
  requireSymptomCode1: false,
  requireSymptomCode2: false,
  requireSymptomCode3: false,
  requireSymtomText: false,
  requireTravelTime: false,
  requireTravelTimeReturn: false,
  requireWorkTime: false,
  requireWorkTimeReturn: false,
  requiredSolutionDescription: false,
  sendMailToCustomer: false,
  sendMailToCustomerDefault: false,
  storeSignaturesLocal: false,
  workTimeStart: "07:00",
  workTimeEnd: "17:00",
  actionCodeStrongRelation: false,
  symptomCodeStrongRelation: false,
  allowEditTimes: false,
  plannerAllDept: false,
};

export default technicianSettings;
